
import { Component, Vue } from "vue-property-decorator";
import { sanitizeSvg } from "@/sanitizeSvg";
import { EquipmentType } from "@/survey";
import {
  getStandardEquipmentIconKey,
  renderStandardEquipmentTypeIconSvg
} from "@/equipmentIconLibrary";

@Component({
  components: {}
})
export default class EquipmentTypeTable extends Vue {
  apiLocation = Vue.prototype.$apiLocation;
  sanitizeSvg = sanitizeSvg;

  renderIcon(equipmentType: EquipmentType) {
    if (getStandardEquipmentIconKey(equipmentType.name) !== null) {
      return renderStandardEquipmentTypeIconSvg(
        equipmentType.name,
        equipmentType.color || "#ff1f1f"
      );
    }
    return sanitizeSvg(equipmentType.iconSvg);
  }

  data() {
    return {
      filter: ""
    };
  }

  get fields() {
    return [
      { key: "name", sortable: true },
      { key: "iconSvg", sortable: false, label: "Icon" },
      { key: "actions", sortable: false },
    ];
  }

  get equipmentTypes() {
    return this.$store.state.equipmentTypes;
  }
}
